const url = 'pessoas';
class PessoaIntegracaoService {
    async autoComplete(nomeCpf, size = 10) {
        if (`${nomeCpf}`.length <= 2) {
            return [];
        }
        const response = await window.$http.get(`${url}/auto-complete`, {
            params: { nomeCpf, size },
        });
        return response.data;
    }
}

export default new PessoaIntegracaoService();
